export default __webpack_public_path__ + "static/media/FRC.7043f9e0.svg";